
import Layout from "./layout/Layout";
import store from "./redux/store";
import { createTheme, ThemeProvider } from "@mui/material";
import { LOGOUT } from "./redux/actions/actionTypes";
import { loadUser } from "./redux/actions/auth.actions";
import { useEffect } from "react";
import {setAuthToken} from "./services/setAuthToken";
import ToastContainerPopup from "./services/toastify/toastifyContainer";
import { useSelector } from "react-redux";
const theme = createTheme({
  palette: {
    primary: {
      main: "rgba(0, 165, 162, 0.7)",
    },
    secondary: {
      main: "#a8c76a",
    },
  },
});

const App = () => {
  const { isAuthenticated } = useSelector((state) => state.authReducer);
  // console.log(isAuthenticated,"isAuthenticated")
  
  useEffect(() => {
    // check for token in LS when app first runs
    if (localStorage.token && isAuthenticated === true) { 
      // if there is a token set axios headers for all requests
      setAuthToken(localStorage.token);
    }

    // try to fetch a user, if no token or invalid token we
    // will get a 401 response from our API
    store.dispatch(loadUser());

    //log user out from all tabs if they log out in one tab
    window.addEventListener("storage", () => {
      if (!localStorage.token) {
        store.dispatch({ type: LOGOUT })
        setAuthToken("")
      };
    });
  }, []);
  return (
    <ThemeProvider theme={theme}>
      <ToastContainerPopup />
      <Layout />
    </ThemeProvider>
  );
};

export default App;
